import { Injectable } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/core';
import { ImaginaeToken } from 'src/app/models/imaginae-token.model';
import { globals } from 'src/utils/globals';

@Injectable()
export class TransferStateService {
  currentValue: any;
  constructor(
    private _transferState: TransferState,
    private _globals: globals
  ) {
  }

  /**
   *	Guarda una nueva preferencia.
   **/
  setItem(key: string, defaultValue: any) {
    let itemKey = makeStateKey(key);
    this._transferState.set(itemKey, defaultValue);
  }

  /**
   *	Devuelve una preferencia.
   **/
  getItem(key: string, defaultValue: any = null) {
    let itemKey = makeStateKey(key);

    return this._transferState.get(itemKey, defaultValue);
  }

  /**
   *	Guarda un conjunto de preferencias.
   **/
  setObject(key: string, value: any) {
    this.setItem(key, value);
  }

  /**
   *	Devuelve un conjunto de preferencias.
   **/
  getObject(key: string) {
    let obj: any = this.getItem(key);
    return !obj ? null : obj;
  }

  /**
   *	Elimina una preferencia.
   **/
  removeItem(key: string) {
    let itemKey = makeStateKey(key);
    this._transferState.remove(itemKey);
  }

  /*  clear() {
    this.currentValue = null;
    for (let key in this._transferState.) {
      this._transferState.remove(this.keysTransferState.get(key) as any);
    }
  }*/

  getToken(): ImaginaeToken | null {
    return this.getItem(this._globals.constants.STORAGE_TOKEN_INFO, null);
  }

  setToken(tokennow: ImaginaeToken | null) {
    this.setItem(this._globals.constants.STORAGE_TOKEN_INFO, tokennow);
  }
}
